import mixins from 'vue-typed-mixins';

import { 事業所Api, 事業所Request } from '@/openapi/user';
import { E消費税区分, E端数処理, E経理方式, E製造原価科目未使用フラグ, E課税方式 } from '@/openapi/enum';

import AlertMixin from '@/mixins/AlertMixin';
import RoutesMixin from '@/entries/user/mixins/RoutesMixin';

import UserApiUtility from '@/classes/common/UserApiUtility';

export default mixins(AlertMixin, RoutesMixin).extend({
  name: 'P事業所Edit',

  data(): {
    api: 事業所Api;
    isCreate: boolean;
    request: 事業所Request;
    e消費税区分: typeof E消費税区分;
    e課税方式: typeof E課税方式;
    e経理方式: typeof E経理方式;
    e端数処理: typeof E端数処理;
    e製造原価科目未使用フラグ: typeof E製造原価科目未使用フラグ;
  } {
    return {
      api: UserApiUtility.ogApi(事業所Api),
      isCreate: false,
      request: {
        c事業所コード: '',
        c事業所名: '',
        c決算月: 1,
        c事業所住所: '',
        c事業所電話番号: '',
        c事業所代表者名: '',
        c担当者名: '',
        c担当者メールアドレス: '',
        c担当者パスワード: '',
        c計画作成期間: 0,
        c計画0期の決算期: -1,
        c消費税区分: E消費税区分.免税事業者,
        c消費税率: 0,
        c課税方式: E課税方式.本則課税,
        c経理方式: E経理方式.税抜経理,
        c簡易課税事業区分: 1,
        c消費税端数処理: E端数処理.切上げ,
        c減価償却費端数処理: E端数処理.切上げ,
        c実績値及び計画値端数処理: E端数処理.切上げ,
        c製造原価科目未使用フラグ: E製造原価科目未使用フラグ.使用する,
      },
      e消費税区分: E消費税区分,
      e課税方式: E課税方式,
      e経理方式: E経理方式,
      e端数処理: E端数処理,
      e製造原価科目未使用フラグ: E製造原価科目未使用フラグ,
    };
  },

  async created(): Promise<void> {
    this.isCreate = this.$route.name === this.routes.事業所Create.name;
    if (this.isCreate) return;

    const response = await this.api.show事業所(Number(this.$route.params.pk));
    Object.assign(this.request, response.data);
  },

  methods: {
    async save(): Promise<void> {
      const response = this.isCreate
        ? await this.api.create事業所(this.request)
        : await this.api.update事業所(Number(this.$route.params.pk), this.request);

      if (this.isValidationErrorResponseToSave(response)) return;
      this.$router.push(this.routes.事業所List);
    },

    漢数字(index: number): string {
      const 漢数字 = ['一', '二', '三', '四', '五', '六'];
      return 漢数字[index - 1];
    },
  },
});
